import type { UpdateWorkPreferencesEnvironmentDto } from '@/modules/worker/types';
import type { Environment } from '@/types/worker';

/**
 * worker-command may expose `extendedStanding` while the UI `Environment` type uses `extendedStandingPosition`.
 * When only one key is present, mirror it so components can read either shape consistently.
 */
export const normalizeWorkerEnvironmentFromApi = (
	raw: Record<string, unknown>
): Record<string, unknown> => {
	const standing = raw.extendedStandingPosition ?? raw.extendedStanding;
	if (standing === undefined) {
		return { ...raw };
	}
	return {
		...raw,
		extendedStandingPosition: raw.extendedStandingPosition ?? standing,
		extendedStanding: raw.extendedStanding ?? standing,
	};
};

export const mapEnvironmentToWorkPreferencesPatchBody = (
	env: Environment
): UpdateWorkPreferencesEnvironmentDto => ({
	negativeCold: env.negativeCold,
	positiveCold: env.positiveCold,
	noise: env.noise,
	smells: env.smells,
	dust: env.dust,
	sustainedPace: env.sustainedPace,
	extendedStanding: env.extendedStandingPosition,
	heavyLoads: env.heavyLoads,
});
